import Auth from '@js/plugins/auth';

export function abortIfNotPermitted(permission, next) {
    if (Auth.hasPermissionTo(permission)) {
        next();
        return;
    }

    next(false);
}



// WEBPACK FOOTER //
// ./resources/assets/js/router/utils.js